import { CustomMarker } from '../GoogleMap/partials/CustomMarker'

export default CustomMarker
